
import { locale } from './globals.js';
const playButton = function (date) {
  return `<div class="play-button"><i class="fal icon fa-play"></i></div>`
}
class VideoHandler {
  constructor(el) {
    if(!el) return false;
    if (el.hasAttribute('data-inited')) return;
    this.el = el;
    this.el.setAttribute('data-inited', true);
    this.el.innerHTML += playButton();
    this.video = this.el.querySelector('video');
    this.video.addEventListener('click', () => {
      if(this.video.paused) {
        if(this.dragged) return;
        this.video.play();
      }
    })
    this.video.addEventListener('play', () => {
      this.video.classList.add('playing');
      this.video.setAttribute('controls', true);
    })
    this.video.addEventListener('pause', () => {
      this.video.classList.remove('playing');
      this.video.removeAttribute('controls');
    })
    
    setTimeout(this.sliderParent.bind(this), 500);
  }
  sliderParent() {
    let slider = this.el.closest('.flickity-enabled');
    if (slider) {
      this.flkty = Flickity.data(slider);
      this.flkty.on('dragStart', () => {
        this.dragged = true;
        this.video.pause();
      })
      this.flkty.on('change', () => {
        this.video.pause();
      })
      this.flkty.on('dragEnd', () => {
        setTimeout(() => {this.dragged = false;}, 200);
      })
    }
  }
  
}
export function initAll () {
	Array.from(document.querySelectorAll('[data-video-handler]')).forEach((elem, index) => {
		init(elem);
	});	
};

export function init(elem) {
  new VideoHandler(elem);
}

export default function (elem) {
	if (!elem || elem.length < 1) {
		initAll();
	} else {
	  init(elem);
	}
}